import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useParams } from "react-router-dom";

export default function CreateFacilityTypePage() {
    const { id } = useParams(); // يظهر فقط عند التعديل
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    // الحقول
    const [name, setName] = useState("");

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    // جلب بيانات النوع عند التعديل
    useEffect(() => {
        if (!id) return; // في حالة الإضافة لا نحتاج لجلب البيانات

        const fetchFacilityType = async () => {
            try {
                const res = await backEnd_request.get(`/FacilityTypes/${id}`);
                const type = res.data;

                setName(type.name ?? "");
            } catch (err) {
                console.log(err.response?.data || err);
                setErrorMessage("فشل جلب بيانات النوع");
            }
        };

        fetchFacilityType();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        const payload = {
            name: name.trim(),
        };

        try {
            if (id) {
                // تعديل
                await backEnd_request.put(`/FacilityTypes/${id}`, payload);
                navigate("/admin/facilitytypes-management", {
                    state: { successMessage: "تم تعديل النوع بنجاح ✅" }
                });
            } else {
                // إضافة
                await backEnd_request.post("/FacilityTypes", payload);
                navigate("/admin/facilitytypes-management", {
                    state: { successMessage: "تم إضافة النوع بنجاح ✅" }
                });
            }
        } catch (err) {
            console.log(err.response?.data || err);
            setErrorMessage(err.response?.data?.message || "حدث خطأ أثناء الحفظ");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-5">
            <h3 className="fw-bold text-primary mb-4">
                {id ? "تعديل نوع منشأة" : "إضافة نوع منشأة جديد"}
            </h3>

            {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

            <form key={id || "new"} onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">اسم النوع</label>
                    <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        placeholder="أدخل اسم النوع..."
                    />
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "جاري الحفظ..." : id ? "تعديل النوع" : "إضافة النوع"}
                </button>

                <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={() => navigate("/admin/facilitytypes-management")}
                >
                    إلغاء
                </button>
            </form>
        </div>
    );
}
